import { useCallback, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import { BottomNav } from "@/components/BottomNav";
import { api } from "@/lib/api";

const OWNER_ALERTS_BADGE_LIMIT = 100;

export function ProtectedLayout() {
  const { user, loading, isOwner } = useAuth();
  const [ownerAlertsUnreadCount, setOwnerAlertsUnreadCount] = useState(0);

  const refreshOwnerAlertsUnreadCount = useCallback(async () => {
    if (!user || !isOwner) {
      setOwnerAlertsUnreadCount(0);
      return;
    }

    try {
      const response = await api.get("/owner-alerts", {
        params: {
          status: "unread",
          limit: OWNER_ALERTS_BADGE_LIMIT,
        },
      });
      setOwnerAlertsUnreadCount(Array.isArray(response.data) ? response.data.length : 0);
    } catch (error) {
      setOwnerAlertsUnreadCount(0);
    }
  }, [isOwner, user]);

  useEffect(() => {
    refreshOwnerAlertsUnreadCount();
  }, [refreshOwnerAlertsUnreadCount]);

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="auth-loading-state"
      >
        Caricamento...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex" data-testid="protected-layout">
      <div className="hidden md:block">
        <Sidebar ownerAlertsUnreadCount={ownerAlertsUnreadCount} />
      </div>
      <div className="min-w-0 flex-1 min-h-screen bg-slate-50">
        <Topbar />
        <main
          id="main-content"
          tabIndex={-1}
          className="mobile-bottom-nav-clearance px-4 md:px-8 py-4 md:py-6 outline-none"
          data-testid="main-content"
        >
          <Outlet context={{ refreshOwnerAlertsUnreadCount }} />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
